<template>
  <v-container>
    <page-header-title v-if="!enrolmentDone" :title="$t('fe.enrolment.interest_title')" class="enr-title"></page-header-title>

    <v-form ref="form">
      <v-container grid-list-md class="pa-0">
        <v-layout wrap>
          <v-flex xs12 v-if="!enrolmentDone">
            <v-container grid-list-md class="pa-0">
              <v-layout wrap>
                <v-flex lg8 md8 sm12 xs12 v-if="!enrolmentDone">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text class="pa-4 enr-course-description">
                        <span style="white-space: break-spaces">{{ $t("fe.enrolment.interest_description") }}</span>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-tabs background-color="var(--v-primary-darken2)" class="enr-tabs" dark v-model="active_tab" grow>
                    <v-tab :to="'/f/' + this.locale + '/enrolment/organisation/interest'" class="subheading">{{
                      $t("fe.enrolment.organisation_title")
                    }}</v-tab>
                    <v-tab :to="'/f/' + this.locale + '/enrolment/personal/interest'" class="subheading">{{
                      $t("fe.enrolment.personal_title")
                    }}</v-tab>
                  </v-tabs>

                  <v-card>
                    <v-card-text class="pa-4">
                      <v-container grid-list-md class="pa-0">
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-subheader class="pl-0">{{ $t("fe.enrolment.details") }}</v-subheader>
                            <v-layout wrap>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-text-field
                                  name="p_first_name"
                                  v-model="enrolment.first_name"
                                  class="required-field"
                                  v-validate="'required|max:50'"
                                  :label="$t('fe.enrolment.p_first_name')"
                                  :error-messages="errors.collect('p_first_name')"
                                  :disabled="fields_disabled"
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-text-field
                                  name="p_last_name"
                                  v-model="enrolment.last_name"
                                  class="required-field"
                                  v-validate="'required|max:50'"
                                  :label="$t('fe.enrolment.p_last_name')"
                                  :error-messages="errors.collect('p_last_name')"
                                  :disabled="fields_disabled"
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-text-field
                                  name="p_email"
                                  v-model="enrolment.email"
                                  class="required-field"
                                  v-validate="'required|email|max:255'"
                                  :label="$t('fe.enrolment.p_email')"
                                  :error-messages="errors.collect('p_email')"
                                  :disabled="fields_disabled"
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <vue-tel-input-vuetify
                                v-validate="'required|max:50'"
                                :label="$t('fe.enrolment.p_mobile')"
                                class="required-field"
                                v-model="enrolment.mobile"
                                @input="
                                  (formattedNumber, { number, valid, country }) => {
                                    enrolment.mobile = number.significant || formattedNumber
                                    enrolment.mobile_code = country.dialCode || null
                                  }
                                "
                                placeholder=""
                                name="p_mobile"
                                :error-messages="errors.collect('p_mobile')"
                                defaultCountry="NO"
                                :disabled="fields_disabled"
                              ></vue-tel-input-vuetify>
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-dialog ref="dialog" v-model="dob_date_menu" persistent width="290px">
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      name="p_date_of_birth"
                                      v-model="computedDateofBirth"
                                      :label="$t('fe.enrolment.p_date_of_birth')"
                                      class="required-field"
                                      v-validate="'required|validDate'"
                                      :error-messages="errors.collect('p_date_of_birth')"
                                      append-icon="event"
                                      @click:append="dob_date_menu = true"
                                      :hint="'Format: ' + DATE_FORMAT"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    color="primary"
                                    v-model="enrolment.date_of_birth"
                                    first-day-of-week="1"
                                    :disabled="fields_disabled"
                                    :locale="$locale_bcp47(locale)"
                                    :max="moment().subtract(1, 'days').format(MYSQL_DATE_FORMAT)"
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" class="darken-2" @click="dob_date_menu = false">{{
                                      $t("global.ok")
                                    }}</v-btn>
                                  </v-date-picker>
                                </v-dialog>
                              </v-flex>
                              <v-flex xs12>
                                <v-textarea
                                  name="p_comments"
                                  v-model="enrolment.comments"
                                  rows="2"
                                  auto-grow
                                  :label="$t('fe.enrolment.comment')"
                                  :error-messages="errors.collect('p_comments')"
                                  :v-validate="selectedCourseTypes.length > 0 ? '' : 'required'"
                                  :class="selectedCourseTypes.length > 0 ? '' : 'required-field'"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>

                            <v-divider class="my-4"></v-divider>

                            <v-subheader class="pl-0">{{ $t("courses.address_title") }}</v-subheader>

                            <v-layout wrap>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-text-field
                                  name="p_address_street"
                                  v-model="enrolment.street"
                                  v-validate="'max:50'"
                                  :label="$t('fe.enrolment.p_address_street')"
                                  :error-messages="errors.collect('p_address_street')"
                                  :disabled="fields_disabled"
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg2 md4 sm6 xs12>
                                <v-text-field
                                  name="p_address_zip"
                                  v-model="enrolment.zip"
                                  v-validate="'max:6'"
                                  :label="$t('fe.enrolment.p_address_zip')"
                                  :error-messages="errors.collect('p_address_zip')"
                                  :disabled="fields_disabled"
                                  @blur="invoiceZipCodeChange"
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md2 sm6 xs12>
                                <v-text-field
                                  name="p_address_city"
                                  v-model="enrolment.city"
                                  v-validate="'max:50'"
                                  :label="$t('fe.enrolment.p_address_city')"
                                  :error-messages="errors.collect('p_address_city')"
                                  :disabled="fields_disabled"
                                  autocomplete="new-password"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg3 md2 sm6 xs12>
                                <v-autocomplete
                                  name="p_address_country"
                                  v-model="enrolment.country"
                                  :items="this.$dd_countries()"
                                  item-text="text"
                                  item-value="key"
                                  :label="$t('fe.enrolment.p_address_country')"
                                  autocomplete="new-password"
                                  :error-messages="errors.collect('p_address_country')"
                                  :disabled="fields_disabled"
                                  clearable
                                ></v-autocomplete>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12 v-if="!enrolmentDone">
                  <v-card>
                    <v-card-text class="pa-4">
                      <p>{{ $t("fe.enrolment.interest_select_courstypes") }}</p>
                      <v-checkbox
                        v-for="coursetype in coursetypes"
                        :key="coursetype.id"
                        v-model="selectedCourseTypes"
                        :label="coursetype.name"
                        :value="coursetype.id"
                        hide-details
                      ></v-checkbox>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>

          <v-flex xs12 v-if="!enrolmentDone">
            <v-divider class="my-2"></v-divider>
            <v-card class="bottom-card">
              <v-card-text class="pa-1">
                <v-container grid-list-md class="pa-0">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-layout wrap>
                        <vue-recaptcha ref="recaptcha" class="captcha d-none" mx-auto :sitekey="RECAPTCHA_KEY"> </vue-recaptcha>

                        <v-flex xs12 class="text-center">
                          <v-checkbox name="coursetype" dense v-model="accept_privacy" v-validate="'required'" class="d-inline-flex">
                          </v-checkbox>
                          <p class="d-inline-flex va-top privacy-line">
                            {{ $t("fe.enrolment.privacy_consent_to") }}
                            <a @click="show_policy = !show_policy" class="pl-1 privacy-link">{{ $t("fe.enrolment.privacy_notice") }}</a>
                          </p>

                          <br />

                          <v-btn class="mb-3" color="primary" large @click="validateEnrol" :disabled="fields_disabled || !accept_privacy">{{
                            $t("fe.enrolment.submit_interest")
                          }}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 v-if="enrolmentDone">
            <v-card class="mx-auto mt-10" max-width="50%" color="success" dark>
              <v-card-title class="headline">{{ $t("fe.enrolment.enrolment_success_noemailsms") }}</v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <privacyPolicy :show="show_policy" :locale="locale" @callback_privacy_cancel="show_policy = false" />
  </v-container>
</template>

<script>
import { VueRecaptcha } from "@/mixins/vue-recaptcha"
import privacyPolicy from "../partials/Privacy"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "EnrolmentPersonalInterest",

  props: ["locale"],

  components: {
    VueRecaptcha,
    privacyPolicy,
    VueTelInputVuetify
  },

  data() {
    return {
      page_title: "",

      enrolment: {},
      enrolmentDone: false,

      coursetypes: [],
      selectedCourseTypes: [],

      available_enrolment: 0,
      fields_disabled: false,
      accept_privacy: false,
      show_policy: false,

      recaptchaData: null,

      active_tab: 0,
      dob_date_menu: false,
      dictionary: {
        attributes: {
          p_course_id: this.$t("fe.enrolment.p_course_id"),
          p_first_name: this.$t("fe.enrolment.p_first_name"),
          p_last_name: this.$t("fe.enrolment.p_last_name"),
          p_email: this.$t("fe.enrolment.p_email"),
          p_mobile: this.$t("fe.enrolment.p_mobile"),
          p_date_of_birth: this.$t("fe.enrolment.p_date_of_birth"),
          p_address_street: this.$t("fe.enrolment.p_address_street"),
          p_address_city: this.$t("fe.enrolment.p_address_city"),
          p_address_state: this.$t("fe.enrolment.p_address_state"),
          p_address_zip: this.$t("fe.enrolment.p_address_zip"),
          p_address_country: this.$t("fe.enrolment.p_address_country"),
          p_comments: this.$t("fe.enrolment.comment"),
          coursetype: this.$t("moduleoptioncoursetypes.coursetype_id")
        }
      }
    }
  },

  computed: {
    computedDateofBirth: {
      get() {
        return this.$dateFormatGetter(this.enrolment.date_of_birth)
      },
      set(val) {
        this.$set(this.enrolment, "date_of_birth", this.$dateFormatSetter(val))
      }
    }
  },

  created() {
    let vm = this

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    axios
      .get(this.API_URL + "open/organisation/my")
      .then((res) => {
        let data = res.data.data
        this.$store.dispatch("frontend/setOrganisation", data)

        this.$setTenantInAxiosHeader(data.tenant_id)

        this.enrolment.country = this.$getDefaultDropdown(this.$dd_countries())
        this.enrolment.mobile_code = "47"

        axios.get(this.API_URL + "open/coursetypes?show_all=true&query_register_interest=1").then((res) => {
          this.coursetypes = res.data.data
        })
      })
      .catch((err) => console.log(err))
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  methods: {
    phoneNoSpace() {
      if (this.enrolment.mobile) {
        this.enrolment.mobile = this.enrolment.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "p_mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    },
    validateEnrol() {
      this.$validator.validate()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.selectedCourseTypes.length == 0 && !this.enrolment.comments) {
            this.$awn.alert(this.$t("fe.enrolment.interest_comment_required"))
            return
          }

          this.enrol()
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },

    enrol() {
      let vm = this

      let vdata = [
        {
          course_id: null,
          first_name: this.enrolment.first_name,
          last_name: this.enrolment.last_name,
          email: this.enrolment.email,
          date_of_birth: this.enrolment.date_of_birth
        }
      ]

      // VALIDATE
      axios
        .post(this.API_URL + "open/enrolment/validate", {
          data: JSON.stringify(vdata)
        })
        .then((res) => {
          let status = res.data.status
          let duplicates = res.data.duplicates

          if (res.data.status == "not-valid") {
            if (duplicates.length > 0) {
              let names = []

              duplicates.forEach((item, index) => {
                names[index] = item.first_name + " " + item.last_name
              })

              vm.$awn.alert(
                vm.$t("fe.enrolment.enrolment_duplicate", {
                  names: names.join(", ")
                })
              )
            }
          } else {
            axios
              .post(this.API_URL + "open/enrolment", {
                site: process.env.VUE_APP_DOMAIN,
                subdomain: vm.SUBDOMAIN,
                course_id: null,
                first_name: this.enrolment.first_name,
                last_name: this.enrolment.last_name,
                email: this.enrolment.email,
                mobile: this.$formatPhoneNumber(this.enrolment.mobile, this.enrolment.mobile_code),
                date_of_birth: this.enrolment.date_of_birth,
                street: this.enrolment.street,
                city: this.enrolment.city,
                state: "",
                zip: this.enrolment.zip,
                country: this.enrolment.country,
                comments: this.enrolment.comments,
                created_by: null,
                type: "personal",
                mode: "interest",
                coursetypes: this.selectedCourseTypes.join(","),
                course_full: false
              })
              .then((res) => {
                if (typeof res.data.errors !== "undefined") {
                } else {
                  let ids = res.data.ids || null

                  if (ids) {
                    vm.$refs.form.reset()
                    vm.errors.items = []
                    vm.accept_privacy = false
                    vm.enrolmentDone = true
                    window.scrollTo(0, 0)
                  } else {
                    vm.$swal({
                      text: vm.$t("fe.enrolment.enrolment_error"),
                      icon: "error",
                      closeOnClickOutside: false,
                      closeOnEsc: false
                    })
                  }
                }
              })
              .catch((err) => console.log(err))
          }
        })
        .catch((err) => console.log(err))
    },

    invoiceZipCodeChange() {
      this.$getCity(this.enrolment.zip, this.enrolment.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.enrolment, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.enrolment, "city", null)
        })
    }
  }
}
</script>

<style scoped>
.privacy-line {
  margin-top: 22px;
}
.privacy-link {
  font-size: 14px;
}
.chk-moduleoption {
  height: 30px;
  padding-top: 3px;
  margin-top: 0;
}
.text-gray {
  color: rgba(0, 0, 0, 0.54) !important;
}
.bottom-card {
  box-shadow: none !important;
}
</style>
